import { BaseModel } from '@shared/base/Base.Model';
import { IWebSocketModel } from '@shared/interface/IWebSocketModel';
import { WebSocketModelUtility } from '@shared/utility/WebSocketModel.Utility';

export interface IPingModel {
}

export class PingModel extends BaseModel implements IPingModel, IWebSocketModel {
    public static readonly expectedPacketType: string = 'ping';

    public isIWebSocketModel: boolean = true;
    public packetType: string = null;
    public id: number = null;

    public constructor() {
        super();
    }

    public loadFromWebSocketMessage(message: any): void {
        WebSocketModelUtility.loadProperties(message, this, 'RIFT-WS-PingModel');
    }

    public toWebSocketMessage(): any {
        return {
            ...WebSocketModelUtility.toJson(this),
        };
    }
}
